import React from "react";
import { observer } from "mobx-react";
import { useLocation } from "react-router-dom";

import { useRootAppStore } from "@hooks";
import LoaderSpinner from "@components-shared/LoaderSpinner";
import {
	PopupBody,
	PopupHeader,
} from "@features/chat/desktop/ChatBetSlipSharedPopup";

import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";
import { useFixBody } from "@state/hooks/shared";
import { SharedBetSlipPopupFooter } from "./SharedBetSlipPopupFooter";

export default observer(function SharedBetSlipPopup() {
	const { quickPlayStore } = useRootAppStore();

	const { sharedBetSlipStore } = quickPlayStore;
	const betSlipData = sharedBetSlipStore.sharedBetSlipPopup;

	const location = useLocation();

	useFixBody(true, sharedBetSlipStore.isPopupDisplayed);

	if (
		!location.pathname.includes("home") &&
		!location.pathname.includes("shared-bet-slips")
	) {
		sharedBetSlipStore.deactivatePopup();
	}

	if (
		sharedBetSlipStore.betSlipShareDetails.isFetchingData &&
		!sharedBetSlipStore.blockMainLoader
	) {
		return <LoaderSpinner isLoading />;
	}

	if (!betSlipData) {
		return null;
	}

	return (
		<MyBetsStoreContext.Provider
			value={sharedBetSlipStore.betSlipShareDetails}
		>
			<div className="popup popup--full popup--shared">
				<div className="popup__card popup--most__card">
					<PopupHeader onClose={sharedBetSlipStore.deactivatePopup} />
					<PopupBody bet={betSlipData} />
					<SharedBetSlipPopupFooter bet={betSlipData} />
				</div>
			</div>
		</MyBetsStoreContext.Provider>
	);
});
